/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useMemo, useState, useEffect } from 'react';
import useViewport from 'components/hooks/useViewport';
import { Categories as PlatformCategories } from 'models/business/Platform';
import Performance from 'models/business/Performance';
import API from 'api';
import PerformanceCard from './PerformanceCard';
import NoDataDashboard from './NoDataDashboard';
import Styles from './index.module.css';

const lastMonday = (date) => {
  const newDate = new Date(date);
  if (date.getDay() === 0) {
    newDate.setDate(newDate.getDate() - 6);
  } else {
    newDate.setDate(newDate.getDate() - (newDate.getDay() - 1));
  }
  return newDate;
};

const thisSunday = (date) => {
  const newDate = new Date(date);
  if (date.getDay() > 0) {
    newDate.setDate(newDate.getDate() + (6 - (newDate.getDay() - 1)));
  }
  return newDate;
};

const endingDay = (date) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + 6);
  return newDate;
};

const lastLastWeek = (date) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() - 14);
  return newDate;
};

const lastWeek = (date) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() - 7);
  return newDate;
};

const formatWeek = (date) => {
  const end = endingDay(date);
  const monday = lastMonday(date);
  const sunday = thisSunday(date);
  return `${date.getMonth() + 1}/${date.getDate()} ~ ${end.getMonth() + 1}/${end.getDate()}`;
};

const subtractDays = (date, days) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() - days);
  return newDate.toISOString();
};

const GoogleCurrentMock = new Performance({
  clicks: 15,
  impressions: 25,
  conversions: 10,
  totalConversionValue: 100,
  cost: 5000,
  platform: PlatformCategories.Google,
});

const GooglePreviousMock = new Performance({
  clicks: 10,
  impressions: 20,
  conversions: 4,
  totalConversionValue: 20,
  cost: 6000,
  platform: PlatformCategories.Google,
});

const FacebookCurrentMock = new Performance({
  clicks: 11,
  impressions: 21,
  conversions: 4,
  totalConversionValue: 100,
  cost: 5000,
  platform: PlatformCategories.FacebookCarousel,
});

const FacebookPreviousMock = new Performance({
  clicks: 10,
  impressions: 20,
  conversions: 5,
  totalConversionValue: 80,
  cost: 6000,
  platform: PlatformCategories.FacebookCarousel,
});

function Investment() {
  const { width } = useViewport();
  const [selectedWeek, setSelectedWeek] = useState(new Date());
  const [previousGoogleData, setPreviousGoogleData] = useState(new Performance());
  const [currentGoogleData, setCurrentGoogleData] = useState(new Performance());
  const [previousFacebookData, setPreviousFacebookData] = useState(new Performance());
  const [currentFacebookData, setCurrentFacebookData] = useState(new Performance());
  const [studio, setStudio] = useState('https://datastudio.google.com/embed/reporting/b023c516-4962-4a86-98cd-1723f7718463/page/F3tRC');
  const breakpoint = 340;

  useEffect(() => {
    setStudio(localStorage.getItem('studio'));

    // eslint-disable-next-line consistent-return
    async function fetchGoogleData() {
      // eslint-disable-next-line max-len
      const result = await API.ad.getGooglePerformanceData(subtractDays(new Date(), 14), subtractDays(new Date(), 1));
      result.resultData.sort((a, b) => new Date(a.date) - new Date(b.date));
      if (result.error) {
        alert(result.error.errorMsg);
        return null;
      }
      const performanceData = (result.resultData || []).map((m) => new Performance(m));
      const previousData = new Performance();
      const currentData = new Performance();
      // eslint-disable-next-line no-multi-assign
      previousData.platform = currentData.platform = PlatformCategories.Google;
      performanceData.forEach((p, i) => {
        let targetData = currentData;
        if (i < performanceData.length / 2) targetData = previousData;

        targetData.clicks += p.clicks;
        targetData.impressions += p.impressions;
        targetData.conversions += p.conversions;
        targetData.totalConversionValue += p.totalConversionValue;
        targetData.cost += p.cost;
        // targetData.clickThroughRate += p.clickThroughRate;
      });
      setPreviousGoogleData(previousData);
      setCurrentGoogleData(currentData);
    }
    async function fetchFacebookData() {
      // eslint-disable-next-line max-len
      const result = await API.ad.getFacebookPerformanceData(subtractDays(new Date(), 14), subtractDays(new Date(), 1));
      result.resultData.sort((a, b) => new Date(a.date) - new Date(b.date));
      if (result.error) {
        alert(result.error.errorMsg);
        return null;
      }
      const performanceData = (result.resultData || []).map((m) => new Performance(m));
      const previousData = new Performance();
      const currentData = new Performance();
      // eslint-disable-next-line no-multi-assign
      previousData.platform = currentData.platform = PlatformCategories.FacebookCarousel;
      performanceData.forEach((p, i) => {
        let targetData = currentData;
        if (i < performanceData.length / 2) targetData = previousData;

        targetData.clicks += p.clicks;
        targetData.impressions += p.impressions;
        targetData.conversions += p.conversions;
        targetData.totalConversionValue += p.totalConversionValue;
        targetData.cost += p.cost;
        // targetData.clickThroughRate += p.clickThroughRate;
      });
      setPreviousFacebookData(previousData);
      setCurrentFacebookData(currentData);
    }
    fetchGoogleData();
    fetchFacebookData();
  }, []);

  const date = new Date();

  const renderPCpage = useMemo(() => (
    <div className={Styles.invContainer}>
      <div className={Styles.leftContent} />
      <div className={Styles.midContent}>
        <div className={Styles.title}>{`${date.getMonth() + 1}/${date.getDate()}成效表現`}</div>
        <div className={Styles.dateSelection}>
          <span>
            <span className={Styles.dateSelectionWeekLabel}>
              本週
            </span>
            <span>
              {formatWeek(lastWeek(selectedWeek))}
            </span>
            <span className={Styles.dateSelectionDivider}>|</span>
            <span className={Styles.dateSelectionWeekLabel}>
              上週
            </span>
            <span>
              {formatWeek(lastLastWeek(selectedWeek))}
            </span>
          </span>
        </div>
        <PerformanceCard
          currentPerformance={currentGoogleData}
          previousPerformance={previousGoogleData}
        />
        <PerformanceCard
          currentPerformance={currentFacebookData}
          previousPerformance={previousFacebookData}
        />
        <div style={{ width: '100%', height: 1000 }}>
          {/* {(currentGoogleData.returnOnAdSpend === 0 && currentFacebookData.returnOnAdSpend === 0) ? (
            <NoDataDashboard />
          ) : (
            <iframe title="Data Studio" width="100%" height="1000px" src={studio} frameBorder="0" style={{ border: 0 }} allowFullScreen />
          )} */}
          {(studio.length > 4) ? (
            <iframe title="Data Studio" width="100%" height="1000px" src={studio} frameBorder="0" style={{ border: 0 }} allowFullScreen />
          ) : (
            <NoDataDashboard />
          )}
        </div>
      </div>
      <div className={Styles.rightContent} />
    </div>
  ));

  const renderMobilePage = useMemo(() => (
    // (currentGoogleData.returnOnAdSpend === 0 && currentFacebookData.returnOnAdSpend === 0) ? (
    //   <NoDataDashboard />
    // ) : (
    //   <iframe title="Data Studio" width="100%" height="2900" src="https://datastudio.google.com/embed/reporting/a7ec04be-2840-4b01-8d86-e36dd4e50a0e/page/F3tRC" frameBorder="0" style={{ border: 0 }} allowFullScreen />
    // )
    (studio.length > 4) ? (
      <iframe title="Data Studio" width="100%" height="2900" src="https://datastudio.google.com/embed/reporting/a7ec04be-2840-4b01-8d86-e36dd4e50a0e/page/F3tRC" frameBorder="0" style={{ border: 0 }} allowFullScreen />
    ) : (
      <NoDataDashboard />
    )
  ));

  return (
    <>
      {width > breakpoint ? renderPCpage : renderMobilePage}
    </>
  );
}

export default Investment;
